const arrayToQueryString = (name: string, array: string[]): string =>
  array.map((item) => `${name}[]=${item}`).join('&');

export default arrayToQueryString;
